// English. Same shape as id.js; any key missing here falls back to Indonesian.
const en = {
    common: {
        back: 'Back',
        close: 'Close',
        menu: 'Menu',
        login: 'Log in',
        redirecting: 'Redirecting...',
        sessionExpired: 'Your session has expired. Please log in again.',
        genericError: 'Something went wrong. Please try again.',
        days: '{n} Days',
        packages: '{n} Packages',
        popular: 'Popular',
        promo: 'Promo',
        topUp: 'Top Up',
        sort: 'Sort',
        seeAll: 'See All',
    },
    help: {
        title: 'Need Help?',
        desc: "Don't worry, we'll help until it's sorted.",
        cta: 'Chat Now',
    },
    nav: {
        shop: 'Shop',
        esim: 'eSIM',
        profile: 'Profile',
    },
    language: {
        label: 'Language',
        choose: 'Choose Language',
    },
    home: {
        title: 'Stay Connected **Without Limits** Abroad!',
        cta: 'Fast internet access anywhere with Arta Mobile!',
        networkText: 'Get access to the best networks around the world',
        networkAria: 'Our network partners',
        promoTitle: 'On Promo!',
        prev: 'Previous',
        next: 'Next',
        otherPackages: 'More Packages',
        categoryAria: 'Country category',
        tabs: {
            popular: 'Popular Countries',
            umrah: 'Umrah / Hajj',
            multi: 'Multi Country',
        },
        openRegion: 'Open {name}',
        startingFrom: 'Starting from',
        loadError: 'Failed to load destinations.',
        retry: 'Try Again',
        empty: 'No destinations in this category.',
        showLess: 'Show Less',
        howTitle: 'No Hassle! How to Use eSIM',
        steps: [
            { title: 'Buy a Package', desc: 'Pick one for your destination' },
            { title: 'Scan QR', desc: 'Install & activate in seconds' },
            { title: 'Ready to Go', desc: 'Enjoy the internet abroad' },
        ],
        faqTitle: 'FAQ',
        faqs: [
            {
                q: 'What is an eSIM?',
                a: "An eSIM (embedded SIM) is a digital SIM built right into your device. You can activate a data plan without a physical SIM card — just scan a QR code and you're connected.",
            },
            {
                q: 'Does my phone support eSIM?',
                a: "Most iPhones (XS and newer), Samsung Galaxy S20 and newer, Google Pixel 3 and newer, and many other flagship Android devices support eSIM. Make sure your phone isn't carrier-locked.",
            },
            {
                q: 'When does the eSIM become active?',
                a: "The eSIM activates automatically the first time you connect to a network in your destination country, so there's no need to worry about using data before you actually leave.",
            },
            {
                q: 'Can I still receive calls & SMS on my Indonesian number?',
                a: 'Yes. The Arta Mobile eSIM is installed as a second SIM. The Indonesian number on your main SIM stays active for calls and SMS, while the eSIM is used for internet data.',
            },
            {
                q: 'How long is a package valid, and what happens when my data runs out?',
                a: "Validity depends on the package you choose (from 3 to 30 days). If your data runs out before the validity period ends, the connection stops automatically. You can buy a new package any time.",
            },
            {
                q: "What if the QR code can't be scanned?",
                a: "Make sure you install the eSIM while connected to the internet (Wi-Fi). If the QR code still can't be read, you can enter the activation code manually. Contact our team on WhatsApp if you're still stuck — we're here to help 24/7.",
            },
        ],
        footerDesc: 'Arta Mobile is an eSIM by PT. Arta Komunikasi Global, here to make your trips abroad easier.',
        followUs: 'Follow Us',
    },
    search: {
        placeholder: 'Search destination country',
        clear: 'Clear search',
    },
    region: {
        loading: 'Loading…',
        loadError: 'Failed to load.',
        topbarTitle: '{name} eSIM',
        desc: 'Enjoy smooth 5G connectivity in {name} with our local networks.',
        pillSpeed: '4G/5G Speed',
        pillHotspot: 'Hotspot Available',
        bannerTitle: 'Ready to connect?',
        bannerSub: 'Check if Your Phone Supports eSIM',
        bannerCta: 'Check Here',
        packagesTitle: 'Available Packages',
        packagesSub: 'Choose the best data package for your trip.',
        listView: 'List view',
        gridView: 'Grid view',
        sortOptions: {
            default: 'Default Order',
            'price-asc': 'Lowest Price',
            'price-desc': 'Highest Price',
            'data-desc': 'Most Data',
            'data-asc': 'Least Data',
        },
        simCardTab: 'SIM Card',
        simCardTitle: 'Saudi Arabia SIM Card',
        simCardSub: "Phone doesn't support eSIM? Use an Arta Mobile physical SIM",
        simCardCta: 'Order on Shopee',
        advTitle: 'Why Choose Us',
        advSub: 'Enjoy the ease and comfort of using our eSIM in {name}.',
        advantages: [
            { title: 'Validity Period', desc: 'Starts automatically when the eSIM connects to a network in your destination' },
            { title: 'No Registration', desc: 'No ID card or passport needed' },
            { title: 'Top Up Anytime', desc: 'Add data easily while travelling' },
        ],
        otherTitle: 'More Packages',
        startingFrom: 'From {price}',
        coverageTitle: 'Country Coverage',
        coverageCount: '{n} countries',
        showLess: 'Show less',
        showAll: 'Show all',
    },
    devices: {
        dialogAria: 'eSIM Device List',
        title: 'Device Support',
        version: 'V. 2.4.0 • UPDATED SEPT 2025',
        searchPlaceholder: 'Search your device model...',
        searchAria: 'Search device',
        clearSearch: 'Clear search',
        all: 'All',
        models: '{n} MODELS',
        others: 'Other Manufacturers',
        emptyTitle: 'Not found',
        emptyDesc: 'Device "{query}" is not on our list.',
        reset: 'Reset search',
        noteTitle: 'Device Not Listed?',
        noteDesc: "Devices released after 2021 generally support eSIM. If yours isn't listed, contact support or check your settings.",
    },
    payment: {
        title: 'Payment',
        topupTitle: 'Top Up eSIM {region}',
        emailTopup: 'Top up eSIM ICCID {iccid}',
        emailNew: 'Your eSIM will be sent to {email}',
        methodsTitle: 'Payment Method',
        methods: {
            qris: 'Gopay, Shopeepay, OVO, Dana, LinkAja',
            gopay: 'Pay instantly with the Gopay app',
        },
        promoTitle: 'Promo & Voucher',
        promoPlaceholder: 'Enter promo code',
        promoChecking: 'Checking...',
        promoCheck: 'Apply',
        promoApplied: 'Promo **{code}** applied.',
        promoEmpty: 'Please enter a promo code first.',
        promoNotFound: 'Promo code not found.',
        promoInvalid: 'Promo code not found.',
        consent: 'By tapping the pay button, you agree to the Terms and Conditions and Privacy Policy of artamobile.id',
        total: 'Total Payment',
        processing: 'Processing...',
        payNow: 'Pay Now',
    },
    qris: {
        appbar: 'Awaiting Payment',
        title: 'Complete Your Payment',
        helper: 'Scan this QRIS code with your banking app. Payment will be detected automatically.',
        expired: 'QR Code Expired',
        expiresIn: 'Expires in {time}',
        unknownExpiry: 'Unknown expiry time',
        noQr: 'QR code not available.',
        checkStatusAria: 'Check Payment Status',
        checking: 'Checking...',
        checkStatus: 'Check Status',
        saveToPhotos: 'Save to Photos',
        saveQr: 'Save QR Code',
        shareTitle: 'QRIS Payment',
        shareText: 'Save the image to Photos.',
        statusCreated: "Payment hasn't been received yet. If you've already paid, wait 1–2 minutes and check again.",
        statusExpired: 'The QR code has expired. Please make a new payment.',
        statusOther: 'Payment status: {status}. Please wait a moment.',
        statusError: 'Failed to check status. Try again.',
        total: 'Total Payment',
        copyAmount: 'Copy amount',
        howTitle: 'How to Pay',
        steps: [
            { title: 'Open the App', desc: 'Open your preferred m-banking or e-wallet app (Gopay, OVO, Dana, etc.).' },
            { title: 'Scan QR Code', desc: "Choose 'Scan' or 'Pay' and point your camera at the QR code on this screen." },
            { title: 'Confirm', desc: 'Check the amount, enter your PIN, and the transaction completes automatically.' },
        ],
    },
    paymentStatus: {
        steps: {
            esim: [
                { title: 'Payment Verification', sub: 'Confirmed automatically' },
                { title: 'Creating Your eSIM', sub: 'Connecting to the global provider...' },
                { title: 'Send to Email', sub: 'Instructions will be sent to your inbox' },
            ],
            topup: [
                { title: 'Payment Verification', sub: 'Confirmed automatically' },
                { title: 'Adding Data Package', sub: 'Processing your data package...' },
                { title: 'Data Package Active', sub: 'Your data will be available shortly' },
            ],
        },
        headings: {
            processing: {
                esim: { pill: 'REAL-TIME PROCESS', title: 'Issuing Your eSIM', sub: "We're setting up your connectivity. Please wait a moment." },
                topup: { pill: 'REAL-TIME PROCESS', title: 'Top Up in Progress', sub: "We're adding your data package. Please wait a moment." },
            },
            success: {
                esim: { pill: 'DONE', title: 'eSIM Issued Successfully', sub: 'Your eSIM has been issued and sent to your email.' },
                topup: { pill: 'DONE', title: 'Top Up Successful', sub: 'Your data package has been added.' },
            },
            failed: {
                esim: { pill: 'FAILED', title: 'Payment Failed', sub: "Sorry, the payment couldn't be completed. Please try again." },
                topup: { pill: 'FAILED', title: 'Payment Failed', sub: "Sorry, the payment couldn't be completed. Please try again." },
            },
        },
        orderStatus: 'Order Status',
        orderNotFound: 'Order number not found.',
        appbarTopup: 'Top Up',
        appbarEsim: 'eSIM Issuance',
        backHome: 'Back to Home',
        viewEsims: 'View My eSIMs',
        retry: 'Try Again',
    },
    esims: {
        title: 'My SIM',
        loadingAria: 'Loading your eSIMs',
        active: 'Active',
        archived: 'Archive',
        count: '{n} eSIM',
        newest: 'Newest',
        oldest: 'Oldest',
        loadError: 'Something went wrong while loading your eSIMs.',
        buyNew: 'Buy a new eSIM',
        loginTitle: 'Log In to See Your eSIMs',
        loginDesc: 'Save and manage all your travel data plans in one secure place.',
        emptyActiveTitle: 'No Active eSIMs Yet',
        emptyActiveDesc: 'Start your adventure by choosing the best data package for your next trip.',
        emptyArchiveTitle: 'Archive Is Empty',
        emptyArchiveDesc: "eSIMs that are inactive or no longer used will appear here, keeping your active list tidy.",
        topupTitle: 'Add Data',
        topupSubtitle: 'Choose the data to add to your eSIM',
    },
    esimCard: {
        status: {
            created: 'Ready to Activate',
            inUse: 'Active',
            usedUp: 'Data Used Up',
            expired: 'Expired',
            cancelled: 'Cancelled',
        },
        iccid: 'ICCID: {iccid}',
        purchased: 'Purchased: {date}',
        checkQuota: 'Check Data',
    },
    topupModal: {
        title: 'Add Data',
        subtitle: 'Choose the data package you want to add.',
        empty: 'No top-up packages available yet.',
        validity: 'Valid for {n} days',
    },
    esimDetail: {
        loadError: 'Failed to load eSIM. Please try again.',
        planStatus: {
            active: 'Active',
            terminated: 'Ended',
            notActive: 'Ready to Install',
        },
        sorts: {
            'price-asc': 'Lowest Price',
            'price-desc': 'Highest Price',
            'data-asc': 'Least Data',
            'data-desc': 'Most Data',
        },
        validUntil: 'Valid until',
        useBefore: 'Use Before',
        shareTitle: '{label} — Arta Mobile',
        shareText: '{label} details on Arta Mobile',
        linkCopied: 'Link copied to clipboard',
        linkCopyFailed: 'Failed to copy link',
        rename: 'Rename',
        share: 'Share',
        sendEmail: 'Send email',
        archive: 'Archive',
        archiveWait: 'Wait for the refund to finish',
        refundStatus: 'Refund status',
        requestRefund: 'Request refund',
        refundChecking: 'Checking…',
        refundBanner: {
            review: { title: 'Refund under CS review', sub: 'Up to {sla}. You can keep using the eSIM during review.' },
            processing: { title: 'Refund in progress', sub: 'Funds are being returned to your original payment method.' },
            done: { title: 'Refund complete', sub: 'Funds have been returned to your original payment method.' },
            rejected: { title: 'Refund rejected', sub: 'See the reason on the refund status page.' },
        },
        installTitle: 'eSIM Installation Guide',
        installSub: 'Activate the eSIM on your device',
        tabQuota: 'Data',
        tabHistory: 'History',
        gbLeft: 'GB LEFT',
        usedData: 'USED DATA',
        totalData: 'TOTAL DATA',
        noHistory: 'No package history yet.',
        validity: 'Validity',
        quota: 'Data',
        ends: 'Ends',
        warningTitle: 'Attention!',
        warningBody: "Don't delete the eSIM. A deleted eSIM can't be installed again.",
        topupTitle: 'Top Up Your Package',
    },
    esimLegacy: {
        loading: 'Loading...',
        warningBody: "Don't delete the eSIM. A deleted eSIM can't be installed again.",
        install: 'eSIM Installation Instructions',
        usage: 'USAGE',
        remaining: 'REMAINING DATA',
        expires: 'Expires',
        myPackages: 'MY PACKAGES',
        expiry: 'Expiry',
        validity: 'Validity',
        days: '{n} Days',
        data: 'Data',
        status: {
            ACTIVE: 'Active',
            TERMINATED: 'Expired',
            NOT_ACTIVE: 'Non-Active',
        },
        renameAria: 'Rename eSIM',
        menuAria: 'Show menu',
        rename: 'Rename',
        shareEmail: 'Share via Email',
        archive: 'Archive eSIM',
        country: 'Country',
        sharedWith: 'Shared with',
        topupHeader: 'TOP UP',
        topupAria: 'Top-up options',
        topupCta: 'Top up',
    },
    renameModal: {
        title: 'Rename eSIM',
        info: "This only changes the eSIM's name in the app — not the name in your device settings.",
        label: 'eSIM name',
        remaining: '{n} characters left.',
        saving: 'Saving…',
        submit: 'Rename eSIM',
        success: 'eSIM name updated!',
        failed: 'Failed to update the eSIM name. Try again.',
    },
    shareModal: {
        title: 'Share via Email',
        info: "Send the eSIM details (including the activation code) to the recipient's email address.",
        label: 'Recipient email',
        placeholder: 'name@example.com',
        invalid: 'Invalid email address.',
        sending: 'Sending…',
        send: 'Send',
        success: 'eSIM details sent to the recipient.',
        failed: 'Failed to send email. Try again.',
    },
    archiveModal: {
        title: 'Archive eSIM?',
        body: "Archived eSIMs won't appear in the main list, but their history stays in the system.",
        confirmQuestion: 'Are you sure you want to archive this eSIM?',
        cancel: 'Cancel',
        archiving: 'Archiving…',
        confirm: 'Archive eSIM',
        success: 'eSIM archived.',
        failed: 'Failed to archive eSIM. Try again.',
    },
    review: {
        title: 'Your Review',
        body: 'Help us keep network quality high in every destination.',
        questionRegion: 'How was the connection in {region}?',
        question: 'How was the connection?',
        submitError: 'Failed to send review. Try again.',
        doneAria: 'Your rating: {n} out of 5',
        thanks: 'Thank you for your review.',
        star: '{n} stars',
        placeholder: 'Write a comment (optional)',
        sending: 'Sending…',
        submit: 'Send review',
    },
    installCard: {
        stages: {
            NOT_STARTED: {
                title: 'eSIM not installed yet',
                body: 'Install the eSIM before you leave. It only takes a few minutes and an internet connection.',
            },
            STALLED: {
                title: 'Installation not finished',
                body: 'Your eSIM installation stopped partway. Please try installing again.',
            },
            INSTALLED: {
                title: 'eSIM installed',
                body: "Don't forget to turn on data roaming in your phone settings.",
            },
            DELETED: {
                title: 'eSIM profile removed from device',
                body: 'This eSIM profile is no longer on your phone.',
            },
        },
        question: 'How was installing this eSIM?',
    },
    install: {
        appbar: 'Choose Method',
        tabsAria: 'Installation mode',
        tabs: {
            instant: 'Instant',
            qr: 'Scan QR',
            manual: 'Manual',
        },
        wifiWarn: 'Make sure your phone has a stable internet connection while installing the eSIM.',
        notIos: 'Instant installation is only available on **iPhone**. Use the **Scan QR** or **Manual** method.',
        oldIos: 'Instant installation is only available on **iOS 17.4** and later. Use the **Scan QR** or **Manual** method.',
        detected: 'Detected Device',
        unknownOs: 'Unknown OS',
        step1: 'Step 1/2 — Install eSIM',
        step2: 'Step 2/2 — Turn On Roaming',
        instantStep: 'Install the eSIM using the button below',
        roaming1: 'Turn on **Data Roaming**.',
        roaming2: 'Set the eSIM as your **Mobile Data** line when you arrive at your destination.',
        installBtn: 'Install eSIM on this iPhone',
        qrLead1: 'Scan the QR below with the phone',
        qrLead2: 'that will use the eSIM',
        qrAlt: 'QR code for eSIM installation',
        qrIphone: '**iPhone**: Settings → Mobile Data → Add eSIM → Use QR Code',
        qrAndroid: '**Android**: Settings → Connections/Network → SIM Manager → Add eSIM → Use QR',
        smdp: 'SM-DP+ Address',
        activationCode: 'Activation Code',
        copy: 'Copy',
        copied: 'Copied',
        manualIphone: '**iPhone**: Settings → Mobile Data → Add eSIM → **Enter Details Manually** (fill in the SM-DP+ Address and Activation Code above)',
        manualAndroid: '**Android**: Settings → Connections/Network → SIM Manager → Add eSIM → **Enter Code**',
        copyFailed: 'Copy failed – please copy manually.',
        iphoneOnly: 'This feature is only available on iPhone.',
        confirm: 'Install the eSIM on this iPhone now?',
    },
    kuota: {
        loadingAria: 'Loading',
        loginTitle: 'Log In to Check Data',
        loginDesc: 'Log in to your Arta Mobile account first to check your SIM card\'s remaining data.',
        linkingAria: 'Linking SIM card',
        linking: 'Linking the SIM card to your account…',
        scanTitle: 'Scan Barcode',
        scanDesc: 'Point the camera at the barcode on your SIM card packaging.',
        cancel: 'Cancel',
        introTitle: 'Check SIM Card Data',
        introDesc: 'Scan the barcode on the SIM card packaging to link it to your account and see your remaining data.',
        scanBtn: 'Scan Barcode',
        hideManual: 'Hide manual input',
        showManual: 'Enter ICCID number manually',
        iccidLabel: 'ICCID Number',
        checkQuota: 'Check Data',
        errors: {
            unrecognized: 'ICCID number not recognised. Try scanning again or enter it manually.',
            unverified: 'Your account is not verified yet. Please verify your email first.',
            notFound: 'SIM card not found. Make sure the barcode on the packaging was scanned correctly.',
            linkFailed: 'Failed to link the SIM card. Please try again.',
            camera: "The camera can't be accessed. Allow camera access in your browser settings, or enter the ICCID number manually.",
        },
    },
    profile: {
        loginTitle: 'Log In to Access Your Profile',
        loginDesc: 'Manage your account and preferences in one place.',
        userFallback: 'User',
        avatarAlt: 'Profile',
        preferences: 'Preferences',
        currency: 'Currency',
        currencyValue: 'IDR - Rupiah',
        support: 'Support',
        contact: 'Contact Us',
        logout: 'Log out',
    },
    refund: {
        slaLabel: '3×24 hours',
        reasons: {
            TRIP_CANCELLED: 'Trip cancelled',
            WRONG_PACKAGE: 'Chose the wrong country or package',
            DEVICE_NOT_SUPPORTED: "Phone doesn't support eSIM",
            OTHER: 'Other',
        },
        ineligible: {
            ESIM_IN_USE: 'eSIM is already active',
            WINDOW_EXPIRED: 'More than 30 days since purchase',
            NOT_SELF_SERVICE: 'Contact CS for a refund',
            PROVIDER_UNAVAILABLE: "Can't be checked right now, try again later",
        },
        status: {
            review: 'Under CS review',
            done: 'Completed',
            rejected: 'Rejected',
            processing: 'Processing',
        },
        payment: {
            credit_card: 'credit card',
            bank_transfer: 'bank transfer',
        },
        request: {
            title: 'Request refund',
            checking: 'Checking eSIM…',
            forbiddenTitle: 'Only the buyer can request a refund',
            forbiddenBody: 'Log in with the email used to buy this eSIM, or contact CS.',
            errorTitle: 'Failed to check eSIM',
            errorBody: 'Please try again in a moment.',
            retry: 'Try again',
            notEligibleTitle: 'Not eligible for a refund',
            notEligibleDefault: "This eSIM isn't eligible for a refund.",
            contactCs: 'Contact CS if you need help.',
            chatCs: 'Chat with CS on WhatsApp',
            eligibleTitle: 'Eligible for a refund',
            eligibleBody: 'Our CS team reviews within {sla}. Funds return automatically to your original payment method — no bank details needed.',
            reasonLegend: 'Refund reason',
            note: 'Note',
            optional: '(optional)',
            notePlaceholder: 'Briefly describe the problem',
            validity: 'Valid for {n} days',
            footerNote: "If approved, the eSIM is deactivated and can't be used again.",
            sending: 'Sending…',
            networkError: 'Connection problem. Try again.',
            submitError: 'Failed to submit the request. Try again or contact CS.',
        },
        statusPage: {
            title: 'Refund status',
            loading: 'Loading refund status…',
            forbidden: 'Only the buyer of this eSIM can see its refund status.',
            loadError: 'Failed to load refund status.',
            retry: 'Try again',
            none: 'No refund request for this eSIM yet.',
            request: 'Request refund',
            toOriginal: 'to original payment method',
            askCs: 'Ask CS on WhatsApp',
            steps: {
                received: 'Request received',
                reviewed: 'Reviewed by CS team',
                reviewSub: 'Up to {sla}. You can keep using the eSIM during review.',
                deactivated: 'eSIM deactivated',
                refunded: 'Funds returned',
                refundedSub: 'Arrival time depends on your bank or e-wallet',
                rejected: 'Rejected',
            },
        },
    },
};

export default en;
